import { Col, Row, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import NavbarLink from './NavbarLink';
import { BROKERSWITHINTEGRATION } from '../../constants/config';
import HomeIcon from '../../assets/icons/bottom-tabs/home.svg?react';
import UsersIcon from '../../assets/icons/bottom-tabs/users.svg?react';
import ClaimsIcon from '../../assets/icons/bottom-tabs/claims.svg?react';
import IntegrationIcon from '../../assets/icons/bottom-tabs/integration.svg?react';

interface MenuProps {
  name: string;
  icon: any;
  link: string;
  highlight: boolean;
}

const Navbar: React.FC = () => {
  const activeMode = useSelector((state: any) => state.auth.activeMode),
    [activeMenu, setActiveMenu] = useState<Array<MenuProps>>([]),
    { brokerName } = useSelector((state: any) => state.theme),
    { isCommercialOnly, userDetails } = useSelector((state: any) => state.data),
    employeeMenu = [
      {
        name: 'Home',
        icon: <HomeIcon style={{ height: '24px', width: '24px', padding: '2px' }} />,
        link: '/home',
        highlight: false,
      },
      {
        id: 2,
        name: 'Claims',
        icon: <ClaimsIcon style={{ height: '24px', width: '24px', padding: '2px' }} />,
        link: '/claims',
        highlight: false,
      },
    ],
    employerMenu = [
      {
        name: 'Dashboard',
        icon: <HomeIcon style={{ height: '24px', width: '24px', padding: '2px' }} />,
        link: '/dashboard',
        highlight: false,
      },
      ...!isCommercialOnly ? [{
        name: 'Members',
        icon: <UsersIcon style={{ height: '24px', width: '24px', padding: '2px' }} />,
        link: '/members',
        highlight: false,
      },
      ...(userDetails?.admin_claims_view_access
        ? [
          {
            name: 'Claims',
            icon: <ClaimsIcon style={{ height: '24px', width: '24px', padding: '2px' }} />,
            link: '/claims',
            highlight: false,
          },
        ]
        : []),
      ...(BROKERSWITHINTEGRATION?.includes(brokerName?.toLowerCase()) || brokerName?.toLowerCase()?.includes('demo')
        ? [
          {
            name: 'Integrations',
            icon: <IntegrationIcon style={{ height: '24px', width: '24px', padding: '2px' }} />,
            link: '/integrations',
            highlight: false,
          },
        ]
        : [])] : [],
    ];

  useEffect(() => {
    if (activeMode === 'employer') {
      setActiveMenu(employerMenu);
    } else {
      setActiveMenu(employeeMenu);
    }
  }, [activeMode, userDetails?.admin_claims_view_access]);

  return (
    <div className="navbar">
      <div className="navbar-items">
        {activeMenu.map((item, index) => (
          <NavbarLink to={item.link} key={index} highlight={item.highlight}>
            <Row align="top" key={index} className="hide-in-collapsed-navbar">
              <Col className="navbar-icon">{item.icon}</Col>
              <Col>
                <span className="nav-page navbar-text">{item.name}</span>
              </Col>
            </Row>
            <div className="show-in-collapsed-navbar">
              <Tooltip title={item.name} placement="right">
                <div className="navbar-icon">{item.icon}</div>
              </Tooltip>
            </div>
          </NavbarLink>
        ))}
      </div>
    </div>
  );
};

export default Navbar;
